import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/CustomButton";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Table from "components/Table/CustomTable";
import { useHistory } from "react-router-dom";
import { getNews } from "views/Services/NewsService";

import { Visibility, CreditCard, Edit } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";

function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US");
}

const useStyles = makeStyles(styles);

const useStylesPrincipal = makeStyles(stylePrincipal);

const NewsList = () => {
  const classes = useStyles();
  const classesPrincipal = useStylesPrincipal();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [news, setNews] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = React.useState(false);
  const tableRef = useRef();

  const goToFirstPage = () => {
    tableRef.current.resetPage(0);
  };

  useEffect(() => {
    if(localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
    fetchNews();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchNews();
      goToFirstPage();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
    }
  };

  const fetchNews = async () => {
    setLoading(true);
    const result = await dispatch(getNews({search: search}));
    if (result.payload && result.payload.data) {
      setNews(result.payload.data);
    }
    setLoading(false);
  };

  const handleChangePage = (newPage) => {
    // You can implement server-side pagination here if needed
    // For now, this is just a placeholder
    console.log("Page changed to: ", newPage);
  }

  const handleAddNew = () => {
    history.push("/admin/addnews");
  };

  const handleView = (id) => {
    history.push(`/admin/addnews/${id}/view`);
  };

  const handleEdit = (id) => {
    history.push(`/admin/addnews/${id}`);
  };

  const fillButtons = (newData) => {
    const styleButton = {
      cursor: "pointer",
      padding: "0px !important",
    };
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/admin/new/${newData.id}/view`)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="View" placement="top" arrow>
              <Visibility
                style={{ color: "#13816F" }}
                fontSize="small"
              ></Visibility>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => history.push(`/admin/newEdit/${newData.id}`)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Edit" placement="top" arrow>
              <EditIcon
                style={{ color: "#13816F" }}
                fontSize="small"
              ></EditIcon>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => {
              handleDelete(newData.id);
            }}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Delete" placement="top" arrow>
              <DeleteIcon
                style={{ color: "#D32F2F" }}
                fontSize="small"
              ></DeleteIcon>
            </Tooltip>
          </GridItem>
        </GridContainer>
      </>
    );
  };

  const handleDelete = (id) => {
    history.push(`/admin/change_new_status/${id}/0`);
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer
            style={{ padding: "20px 0px 40px 0px" }}
            justify="center"
          >
            <GridContainer>
              <GridItem xs={12} md={12}>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card>
                    <CardHeader>
                      <div
                        className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                      >
                        {t("news.title")}
                      </div>
                      <GridContainer>
                        {news && (
                          <>
                            <GridItem xs={12} style={{ marginTop: "15px", textAlign: "right" }}>
                              <GridContainer>
                                <GridItem xs={0} sm={0} md={9}>&nbsp;</GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                  <Button
                                    id="continueMobile"
                                    onClick={() => {
                                      window.location.href = "/admin/new";
                                    }}
                                    style={{ backgroundColor: "#008670" }}
                                    block
                                  >
                                    {t("news.buttons.addNew")}
                                  </Button>
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            <GridItem xs={12} style={{ marginTop: "15px" }}>
                              <GridContainer>
                                <GridItem xs={0} sm={0} md={9}></GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                  <CustomInput
                                    labelText={t("step2.search")}
                                    formControlProps={{
                                      fullWidth: true,
                                      className:
                                        classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                      name: "search",
                                      id: "search",
                                      value: search,
                                      onChange: (e) => {
                                        handleFormChange(e);
                                      },
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            <GridItem xs={12} style={{ marginTop: "15px" }}>
                              <Table
                                ref={tableRef}
                                tableHead={[
                                  t("news.title"),
                                  t("news.type"),
                                  t("news.dashboard"),
                                  t("news.created"),
                                  t("news.action"),
                                ]}
                                rowsPerPage={10}
                                loading={loading}
                                changePage={handleChangePage}
                                tableData={news.map((newItem) => [
                                  newItem.title,
                                  newItem.type,
                                  newItem.user_type,
                                  formatDate(newItem.created),
                                  fillButtons(newItem),
                                ])}
                              />
                            </GridItem>
                          </>
                        )}
                      </GridContainer>
                    </CardHeader>
                  </Card>
                </GridItem>
              </GridItem>
            </GridContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default NewsList;
